import {
  getMissionPlannerData,
  getShowGlobalLoader,
  getBackUrl,
  getCurrentSemanticMapId,
  getActiveTooltipVehicleId,
} from "./selectors";
import AppStateSlice from "./reducers";

// actions
export const {
  setMissionPlannerData,
  setCurrentSemanticMapId,
  setBackUrl,
  setShowGlobalLoader,
  setActiveTooltipVehicleId,
  resetAppState,
} = AppStateSlice.actions;

// selectors
export {
  getMissionPlannerData,
  getShowGlobalLoader,
  getBackUrl,
  getCurrentSemanticMapId,
  getActiveTooltipVehicleId,
};

// reducer
export default AppStateSlice.reducer;
